import { useTranslation } from "react-i18next";
import type { KeptInputNote } from "../../../api/threads/threadDecoders";
import ItemReferenceName from "../../items/ItemReferenceName";

/**
 * A quiet note on a kept step that read an item with a newer version now (threads.md, As
 * built: fork continuation and reruns): the item by its name, the exact versions in the
 * tooltip only. The same in the fork preview and on the Thread's kept step.
 */
export default function KeptInputNoteLine({ note, className }: { note: KeptInputNote; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={className} title={`${note.read} → ${note.now}`}>
      {t("threads.fork.preview.olderVersion")} <ItemReferenceName reference={note.read} link={false} showVersion={false} fallback={note.input} />
    </span>
  );
}
